<template>
  <v-container>
    <v-layout row wrap mt-5 pb-3>
      <v-flex xs12>
        <h3>
          <v-icon large color="yellow">playlist_add_check</v-icon>
          Order-Status
        </h3>
        Here you can browse all orders that you have placed at Evident. Click on
        a row to view a particular order in detail! You have the option to
        filter the list to your needs. The sort order can be changed by clicking
        the switches in the header.
        <blockquote>
          Please note that after placing a new order it will take some time
          before the status information is available!
        </blockquote>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12><order-status-list></order-status-list></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import OrderStatusList from "@/components/OrderStatusList.vue";

export default {
  components: {
    OrderStatusList
  }
};
</script>
